
import cookies from 'js-cookie'
import { defineComponent, ref, SetupContext, getCurrentInstance, computed, inject, watch, onMounted } from 'vue';
import Popup from 'vant/lib/popup';
import Toast from 'vant/lib/toast';
import { getLoginPara, setLoginCookie, kpnClientMap } from '@/common/login';
import { sendLog } from '@/common/radar';
import { getKpn } from '~/common/common-params';

export default defineComponent({
  components: {
    vanPopup: Popup,
  },
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    isIos: {
      type: Boolean,
      default: false
    },
    isAllowClose: {
      type: Boolean,
      default: false
    },
  },
  setup(props, ctx: SetupContext) {
    const { proxy }: any = getCurrentInstance()
    const startupData: any = proxy.$store.state.startup
    const show = ref(false);
    let clientId = ''
    let kpn = ''

    const headerWords = computed(() => {
      return proxy.$root.$t('k_326749').replace('${0}', proxy.$appName)
    })
    const openWords = computed(() => {
      return proxy.$root.$t('open_kwai').replace('${0}', proxy.$appName)
    })
    const subTitle = computed(() => {
      return proxy.$root.$t('k_326750').replace('${0}', proxy.$appName)
    })
    const buttomTitle = computed(() => {
      return proxy.$root.$t('k_326753').replace('${0}', proxy.$appName)
    })


    const handleConfirm = (button_type: string) => {
      sendLog({
        type: 'click',
        name: 'PWA_LOGIN_POP',
        value: {
          button_type
        }
      })
      if (button_type === 'Google') return
      ctx.emit('confirm', { skip_to: 'app' });
    };
    let client = ref<any>();

    const handleClose = () => {
      ctx.emit('close', { button_type: 'close' });
    };

    const login = async (para: any) => {
      const did = cookies.get('webDid')
      proxy.$bus.emit('isLoad', true)
      // const params = getLoginPara(proxy.$store.state.startup);

      const params = getLoginPara({ startup: startupData, kpn });

      let res = await proxy.$axios.$$post(`loginApi::/rest/o/w/user/thirdPlatformLogin?access_token=${para.credential || para.access_token}&platform=google&did=${did}`, params)
      setLoginCookie(res)
      handleClose()

      proxy.$bus.emit('isLoad', false)
      // 服务端service token
      if (res.result === 1 && res['kwaipro.pwa_st']) {
        await proxy.$axios.$$post(`loginApi::/rest/infra/sts`, {
          authToken: res['kwaipro.pwa.at'],
          sid: 'kwaipro.pwa',
          followUrl: location.href,
        })
        Toast({
          message: proxy.$root.$t('k_326761'),
        })
        show.value = false
        ctx.emit('login', true)
      } else {
        Toast({
          message: proxy.$root.$t('k_327320'),
        })
        ctx.emit('login', false)
      }
      proxy.$bus.emit('sendPv');
    }

    let googleInitialize = ref<any>()
    watch(
      () => props.isShow,
      (newValue) => {
        if (newValue) {
          const google = (window as any).google as any
          googleInitialize.value = google.accounts.id.initialize({
            client_id: clientId,
            callback: async (e: any) => {
              if (!show.value) {
                sendLog({
                  type: 'click',
                  name: 'PWA_GOOGLE_POPUP',
                  value: {
                    button_type: 'login'
                  }
                })
              }
              await login(e);
            },
          });

          google.accounts.id.prompt((notification: any) => {
            if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
              // try next provider if OneTap is not displayed or skipped
              if (notification.getSkippedReason() === 'user_cancel') {
                sendLog({
                  type: 'click',
                  name: 'PWA_GOOGLE_POPUP',
                  value: {
                    button_type: 'close'
                  }
                })
              }
              show.value = true;
              sendLog({
                type: 'show',
                name: 'PWA_LOGIN_POP',
                value: {}
              })
              const parent = document.getElementById('container');
              const width = screen.width
              const buttonWidth = Math.floor(width - width / 414 * 54)
              google.accounts.id.renderButton(parent, {
                // theme: "filled_black",
                width: buttonWidth > 400 ? 400 : buttonWidth,
                text: 'continue_with',
                cancel_on_tap_outside: true,
                locale: proxy.$root.$i18n.locale || 'en',
                click_listener: () => {
                  sendLog({
                    type: 'click',
                    name: 'PWA_LOGIN_POP',
                    value: {
                      button_type: 'Google'
                    }
                  })
                }
                // type: 'icon'
              });

              // console.log(container)
            }
            if (notification.isDisplayed()) {
              sendLog({
                type: 'show',
                name: 'PWA_GOOGLE_POPUP',
                value: {}
              })
            }
          });
        } else {
          show.value = false;
        }
      },
      { immediate: true }
    );

    const openService = (type: string) => {
      const language = ['pt-BR', 'es', 'ar', 'id'];
      const path = language.includes(proxy.$root.$i18n.locale) ? `/${proxy.$root.$i18n.locale}` : '';
      // const url = startupData.kpn.toLowerCase() === 'snackvideo' ? `https://www.snackvideo.com${path}/legal?id=${type}` : `https://www.kwai.com${path}/legal?id=${type}`;
      const url = proxy.$isSnack ? `https://www.snackvideo.com${path}/legal?id=${type}` : `https://www.kwai.com${path}/legal?id=${type}`;
      window.open(url);
    }

    onMounted(() => {
      kpn = getKpn({ bucket: proxy.$store.state.startup.bucket, host: window.location.host })
      clientId = kpnClientMap[kpn]
    })

    return {
      show,
      headerWords,
      client,
      openWords,
      buttomTitle,
      subTitle,
      startupData,
      handleConfirm,
      handleClose,
      openService,
    };
  },
})
